import React, { PropsWithChildren } from 'react';

import styles from './DownloadLinkStyle.less';
import { DownloadIcon } from './icons';

export interface IDownloadLinkProps {
  href: string;
  onClick?: () => void;
}

const DownloadLink: React.FC<IDownloadLinkProps & PropsWithChildren> = (props) => (
  <a
    className={styles['od-download-link-container']}
    href={props.href}
    onClick={props.onClick}
    target="_blank"
    // Using target="_blank" without rel="noreferrer noopener"
    // is a security risk in older browsers
    // https://mathiasbynens.github.io/rel-noopener/#recommendations
    rel="noopener noreferrer"
  >
    <div className={styles['od-download-link-icon-wrapper']} title="download icon">
      <div className={styles['od-download-link-icon-container']}>
        <DownloadIcon />
      </div>
    </div>
    {props.children}
  </a>
);

export default DownloadLink;
